import React from 'react';

import { DeleteButton } from 'craft/containers/FloatingMenu/commons/DeleteButton';
import { useFlowDelete } from 'craft/state';

export const DeleteStepButton = ({
  flowId,
  stepId,
  disabled,
  tooltipPlacement,
}: {
  flowId: string;
  stepId: string;
  disabled: boolean;
  tooltipPlacement: 'top' | 'bottom';
}) => {
  const { canDeleteSteps, onDeleteStepId } = useFlowDelete(flowId);

  const onDelete = () => {
    onDeleteStepId(stepId);
  };

  return (
    <DeleteButton
      tooltipPlacement={tooltipPlacement}
      disabled={disabled || !canDeleteSteps}
      onClick={onDelete}
    />
  );
};
